import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { value: String }
  static targets = [ "input", "toggleButton" ]

  connect() {
    this.masked = true
    this.inputTarget.type = "password"
  }

  toggle() {
    if (this.masked) {
      this.inputTarget.type = "text"
    } else {
      this.inputTarget.type = "password"
    }
    this.masked = !this.masked
    this.updateToggleButton()
  }

  updateToggleButton() {
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.textContent = this.masked ? "👁️" : "🙈"
      this.toggleButtonTarget.title = this.masked ? "Show API key" : "Hide API key"
    }
  }
}
